import { render } from "./ArtistView.vue?vue&type=template&id=1d42cb4e&scoped=true&ts=true"
import script from "./ArtistView.vue?vue&type=script&lang=ts"
export * from "./ArtistView.vue?vue&type=script&lang=ts"

import "./ArtistView.vue?vue&type=style&index=0&id=1d42cb4e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d42cb4e"]])

export default __exports__